export default __webpack_public_path__ + "static/media/ava-02.2aa17dbf.png";